export function base64Uint8Array(base64: string) {
	return Uint8Array.from(atob(base64).split("").map(m => m.codePointAt(0)!));
}
